import { useMsal } from "@azure/msal-react";
import { Navigate } from "react-router-dom";

export function ProtectedRoute({ children }) {
  const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return children;
} 